import axios from 'axios';

export default {
  namespaced: true,
  state: {
  },
  getters: {
  },
  mutations: {
  },
  actions: {
    async retrieveVersionById(context, data) {
      try {
        const config = { withCredentials: true };
        if (data && data.sharedToken) config.headers = { Authorization: data.sharedToken };
        const version = await axios.get(`/autodesk/data-management/data-management/projects/${data.projectId}/versions/${data.versionId}`, config);
        return version.data;
      } catch (error) {
        throw error;
      }
    },
  },
};
